module.exports = __webpack_public_path__ + "static/media/call_white.d249393c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/call_white.svg
// module id = 1906
// module chunks = 0